import React from "react";

import PageHeading from "../../components/PageHeading";
import ProductPrimaryForm from "../../components/Forms/ProductPrimaryForm";
// import utils
import * as Yup from "yup";
import { imageFormat, imageSize } from "../../utils/functions";
import DSpinner from "../../components/DSpinner";
import DCard from "../../components/DCard";
import productServices from "../../services/products";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useQueryClient } from "react-query";

const AddProduct = ({ title }) => {
    const { categories } = useSelector(state => state.config);
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const initialValues = {
        productName: "",
        productImage: "",
        category: "",
        orphan: true,
        order: "",
    };
    const validationSchema = Yup.object().shape({
        productImage: Yup.mixed()
            .test("image-format", "يرجى تحميل صورة", value => {
                return value
                    ? imageFormat.includes(value.type.split("/")[1])
                    : false;
            })
            .test("img-size", "حجم الصورة لايجب ان يتجاوز 5mb", value => {
                return value ? imageSize >= value.size : false;
            }),
        productName: Yup.string()
            .required("هذا الحقل مطلوب")
            .min(3, "يجب اني يكون على الاقل 3 احرف"),
        category: Yup.string().required("هذا الحقل مطلوب"),
    });
    // onSubmit primary product
    const onSubmit = (values, { setSubmitting }) => {
        const formData = new FormData();
        formData.append("name", values.productName);
        formData.append("orphan", values.orphan ? 1 : 0);
        if (values.order !== "") {
            formData.append("order", values.order);
        }

        formData.append("img", values.productImage);
        productServices
            .createProduct(formData, values.category)
            .then(res => {
                toast.success("تم اضافة المنتج ");
                queryClient.refetchQueries("getProducts");
                setTimeout(() => {
                    navigate("/products", { replace: true });
                }, 1500);
            })
            .catch(err => {
                console.log(err);
                toast.error("فشلت اضافة المنتج");
                setSubmitting(false);
            });
    };
    return (
        <div>
            <PageHeading>{title}</PageHeading>
            <DCard
                className={categories.loading ? "relative min-h-[400px]" : ""}
            >
                {categories.loading ? (
                    <DSpinner />
                ) : (
                    <ProductPrimaryForm
                        validationSchema={validationSchema}
                        initialValues={initialValues}
                        onSubmit={onSubmit}
                        categoriesOptions={categories.data}
                        btnText={"إضافة المنتج"}
                    />
                )}
            </DCard>
        </div>
    );
};

export default AddProduct;
